export default function () {
    const paramsToRemove = window?.customData?.paramsToRemove

    if (!paramsToRemove || paramsToRemove.length > 0) {
        return
    }

    const url = new URL(window.location)
    paramsToRemove.forEach((param) => url.searchParams.has(param) && url.searchParams.delete(param))

    history.replaceState(history.state, '', url.href)
}
